<template lang="pug">
  div.body.garbage-table.tech-garbage-table.body-flex
    div.table-choose-panel.body-flex
      div.toolbar-table
        .toolbar.toolbar_margin-bottom.toolbar_no-padding
          .toolbar__line
            e-select-list(
              :options="selectListOptions"
              v-model="operationType"
            )
            e-button-add.btn-add-target.actions-panel__button.view-panel__button.view-panel__button_add(@click="addNewRowToGarbageTable")

      div(v-if="operationType === 'production'")
        e-table-editable(
          v-if="canUseGarbageProduction"
          ref="production"
          :attributes="garbageProductionAttr"
          :dataUrl="garbageDataUrl"
          :postUrl="garbagePostUrl"
          :patchUrl="garbagePatchUrl"
          :deleteUrl="garbageDeleteUrl"
          :enableOnAdd="enableOnAdd"
          :afterFetchData="afterFetchData"
          :tableInOnlineMode="tableInOnlineMode"
        )
        div(v-else)
          p Данный вид таблицы недоступен при выбранных видах деятельности

      e-table-editable(
        v-if="operationType === 'input-fkko'"
        ref="input"
        :attributes="garbageInputAttr"
        :dataUrl="garbageDataUrl"
        :postUrl="garbagePostUrl"
        :patchUrl="garbagePatchUrl"
        :deleteUrl="garbageDeleteUrl"
        :enableOnAdd="enableOnAdd"
        :afterFetchData="afterFetchData"
        :tableInOnlineMode="tableInOnlineMode"
      )


      e-table-editable(
        v-if="operationType === 'output-fkko'"
        ref="output"
        :attributes="garbageOutputAttr"
        :dataUrl="garbageDataUrl"
        :postUrl="garbagePostUrl"
        :patchUrl="garbagePatchUrl"
        :deleteUrl="garbageDeleteUrl"
        :enableOnAdd="enableOnAdd"
        :afterFetchData="afterFetchData"
        :tableInOnlineMode="tableInOnlineMode"
      )
</template>

<script>
import { cadastr } from '@/api/api-endpoints'
import { cadastrOffline } from '@/api/api-offline-endpoints'

export default {
  name: 'tech-garbage-table',
  props: {
    id: null,
    tabView: null,
    canUseGarbageProduction: null,
  },
  data() {
    return {
      operationType: null,
      search: '',
      searchModel: '',
    }
  },
  computed: {
    selectListOptions() {
      let options = [
        {
          id: 'input-fkko',
          name: 'Входные отходы',
        },
        {
          id: 'output-fkko',
          name: 'Образовавшиеся отходы в результате применения технологии',
        },
      ]
      if (this.canUseGarbageProduction) {
        options.push({
          id: 'production',
          name: 'Полученная продукция',
        })
      }
      return options
    },
    tableInOnlineMode() {
      return this.$route.params.id
    },
    enableOnAdd() {
      return []
    },
    garbageProductionAttr() {
      return {
        okpdCode: {
          required: true,
          label: 'Код ОКПД2',
          placeholder: 'Начните вводить цифры кода',
          validationRulePattern: '(\\.*)',
          suggestion: {
            options: [],
            onSelect: this.onSelectOKPD,
            suggestionEndpoint: this.suggestionOKPDEndpoint,
            transformSuggestions: this.transformOKPDSuggestions,
          },
        },
        okpdName: {
          disabled: true,
          required: true,
          label: 'Наименование продукции',
          placeholder: ' ',
          validationRulePattern: '(\\.*)',
        },
        count: {
          label: 'Количество (т)',
          placeholder: 'целое число',
          validationRulePattern: '^(\\d*)$',
        },
        certificate_num: {
          label: 'Номер сертификата',
          placeholder: 'целое число',
          validationRulePattern: '^(\\d*)$',
        },
        date_from: {
          label: 'Дата начала',
          placeholder: 'ГГГГ-ММ-ДД',
          validationRulePattern: '(\\.*)',
          calendar: {},
        },
        date_to: {
          label: 'Дата окончания',
          placeholder: 'ГГГГ-ММ-ДД',
          validationRulePattern: '(\\.*)',
          calendar: {},
        },
      }
    },
    garbageInputAttr() {
      return {
        code: {
          label: 'Код ФККО',
          required: true,
          placeholder: '1 000 000',
          validationRulePattern: '^((\\d*\\s*)*)$',
          disabled: true,
        },
        fkkoName: {
          label: 'Наименование',
          validationRulePattern: '(\\.*)',
          placeholder: 'Введите название отхода',
          suggestion: {
            options: [],
            onSelect: this.onSelect,
            suggestionEndpoint: this.suggestionEndpoint,
            transformSuggestions: this.transformSuggestions,
          },
          transform: this.transform,
        },
        danger: {
          label: 'Класс опасности',
          placeholder: 'цифра',
          validationRulePattern: '^(\\d*)$',
          disabled: true,
          required: true,
        },
        power_tons: {
          label: 'Мощность (т/год)',
        },
        power_meters: {
          label: 'Мощность (м<sup>3</sup>/год)',
        },
      }
    },
    garbageOutputAttr() {
      return {
        code: {
          label: 'Код ФККО',
          required: true,
          placeholder: '1 000 000',
          validationRulePattern: '^((\\d*\\s*)*)$',
          disabled: true,
        },
        fkkoName: {
          label: 'Наименование',
          validationRulePattern: '(\\.*)',
          placeholder: 'Введите название отхода',
          suggestion: {
            options: [],
            onSelect: this.onSelect,
            suggestionEndpoint: this.suggestionEndpoint,
            transformSuggestions: this.transformSuggestions,
          },
          transform: this.transform,
        },
        danger: {
          label: 'Класс опасности',
          placeholder: 'цифра',
          validationRulePattern: '^(\\d*)$',
          disabled: true,
          required: true,
        },
      }
    },
    garbageDataUrl() {
      if (this.id) {
        let routeQuery = {
          query: {
            sourceId: this.id,
            type: this.operationType,
          },
        }
        if (this.search) {
          routeQuery.query.q = this.search
        }

        return cadastr.techGarbageOperation(routeQuery)
      }

      // if new record, offline save
      return cadastrOffline.techGarbageOperationTable(
        this.$route.name,
        this.operationType
      )
    },
  },
  methods: {
    onSelectOKPD(ctx, $event, model) {
      if ($event && $event.id) {
        let copy = Object.assign({}, $event)
        model.okpd_id = copy.id
        model.okpdCode = copy.okpdCode
        model.okpdName = copy.okpdName
      } else {
        model.okpd_id = ''
        model.okpdCode = ''
        model.okpdName = ''
      }
    },
    suggestionOKPDEndpoint(ctx, q) {
      return cadastr.okpd({ query: { q, 'per-page': 50 } })
    },
    transformOKPDSuggestions(ctx, response) {
      let data = response.data
      let options = []
      for (let i = 0; i < data.length; i++) {
        options.push({
          name: `${data[i].value} ${data[i].name}`,
          okpdName: data[i].name,
          okpdCode: data[i].value,
          id: data[i].id,
        })
      }
      return options
    },
    afterFetchData(ctx, data) {
      for (let i = 0; i < data.data.length; i++) {
        if (data.data[i].fkko) {
          data.data[i].danger = data.data[i].fkko.danger
          data.data[i].code = data.data[i].fkko.code
        } else {
          data.data[i].danger = ''
          data.data[i].code = ''
        }

        if (data.data[i].okpd && data.data[i].okpd_id) {
          data.data[i].okpdCode = data.data[i].okpd.value
          data.data[i].okpdName = data.data[i].okpd.name
        }
      }
      return data
    },
    transform(model) {
      if (model.fkko && model.fkko.name && model.fkko.hasOwnProperty('name')) {
        if (!model.fkkoName) {
          let copy = Object.assign({}, model.fkko)
          model.danger = copy.danger
          model.code = copy.code
          model.fkkoName = copy.name
        }

        return model.fkko.name
      } else {
        return ''
      }
    },
    onSelect(ctx, $event, model) {
      if ($event && $event.id) {
        let copy = Object.assign({}, $event)
        model.code = copy.code
        model.fkko_id = copy.id
        model.fkkoName = copy.fkkoName
        model.fkko = { name: copy.fkkoName }
        model.danger = copy.danger
      } else {
        model.code = ''
        model.fkko_id = ''
        model.fkkoName = ''
        model.fkko = { name: '' }
        model.danger = ''
      }
    },
    suggestionEndpoint(ctx, q) {
      return cadastr.fkko({ query: { q: q, 'per-page': 50 } })
    },
    transformSuggestions(ctx, response) {
      let data = response.data
      let options = []
      for (let i = 0; i < data.length; i++) {
        options.push({
          name: data[i].code + ' ' + data[i].name,
          fkkoName: data[i].name,
          id: data[i].id,
          code: data[i].code,
          danger: data[i].danger,
        })
      }
      return options
    },
    garbagePostUrl() {
      return cadastr.techGarbageOperationPost({
        query: {
          sourceId: this.id,
          type: this.operationType,
        },
      })
    },
    garbagePatchUrl(context, model) {
      return cadastr.techGarbageOperationPatch({
        query: {
          sourceId: model.id,
          type: this.operationType,
        },
      })
    },
    garbageDeleteUrl(context, model) {
      return cadastr.techGarbageOperationDelete({
        query: {
          sourceId: model.id,
          type: this.operationType,
        },
      })
    },
    addNewRowToGarbageTable() {
      const Model = () => {
        return {
          tech_id: this.id,
          code: '',
          danger: '',
          // can be used for turn year select
          _operationType: JSON.parse(JSON.stringify(this.operationType)),
        }
      }

      if (this.operationType === 'production') {
        this.$refs.production.createRow(new Model())
      } else if (this.operationType === 'input-fkko') {
        this.$refs.input.createRow(new Model())
      } else if (this.operationType === 'output-fkko') {
        this.$refs.output.createRow(new Model())
      }
    },
  },
}
</script>
